import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { QuantityComponent } from './quantity'
import { $elParent } from 'src/scripts/utils/utils'
import { CartPage } from 'src/scripts/sections/cart'

const QUANTITY_COMPONENT = 'quantity-component'

export class QuantityBtn extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleButtonClick)
    this.addListener(this, 'keydown', this.handleKeyDown)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const target = event.target as HTMLElement

    if (isEnterKey(event) && !target.hasAttribute('disabled')) {
      event.preventDefault()
      this.update()
    }
  }

  update(): void {
    const quantity: QuantityComponent = $elParent(QUANTITY_COMPONENT, this)
    const action = this.dataset.action

    if (!quantity && !action) {
      return
    }

    if (action === 'minus' && quantity.value === '1') {
      return this.remove()
    }

    quantity.inputChange(action)
  }

  remove(): void {
    const cart: CartPage = $elParent('cart-page, cart-drawer', this)

    if (cart) {
      const index = $elParent('cart-item', this).dataset.index
      cart.updateItem(+index, 0)
    }
  }
}
